var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_New_Password_250130",
    "data-name": "noun_New Password_250130",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.076,
    height: 26.076,
    viewBox: "0 0 26.076 26.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_63848",
    "data-name": "Path 63848",
    d: "M0,0H26.076V26.076H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63849",
    "data-name": "Path 63849",
    d: "M27.211,12.105H26.124V9.932a5.432,5.432,0,0,0-10.865,0v2.173H14.173A2.179,2.179,0,0,0,12,14.278V25.143a2.179,2.179,0,0,0,2.173,2.173H27.211a2.179,2.179,0,0,0,2.173-2.173V14.278A2.179,2.179,0,0,0,27.211,12.105ZM17.324,9.932a3.368,3.368,0,1,1,6.736,0v2.173H17.324Zm-2.68,9.67h1.63a4.374,4.374,0,0,1,4.382-4.382,4.16,4.16,0,0,1,2.318.688l-.8.8a3.176,3.176,0,0,0-1.521-.4,3.308,3.308,0,0,0-3.3,3.3h1.63l-2.209,2.209Zm10.43,0a4.374,4.374,0,0,1-4.382,4.382,4.16,4.16,0,0,1-2.318-.688l.8-.8a3.176,3.176,0,0,0,1.521.4,3.308,3.308,0,0,0,3.3-3.3h-1.63l2.209-2.209L26.776,19.6h-1.7Z",
    transform: "translate(-7.654 -2.87)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/resetPassword.913497e7ce13498a2e4b0f3322842b09.svg";
export { ForwardRef as ReactComponent };